export default __webpack_public_path__ + "static/team-illustration-cf40d8a0e70017852db957eebdc69bb7.svg";